export function buildEventDeepLinkUrl(pageUrl: string, eventLocalId: string): string {
  const hashIndex = pageUrl.indexOf('#')
  const base = hashIndex === -1 ? pageUrl : pageUrl.substring(0, hashIndex)
  const fragmentParams = new URLSearchParams(hashIndex === -1 ? '' : pageUrl.substring(hashIndex + 1))
  fragmentParams.set('tickaroo_event_id', eventLocalId)
  return base + '#' + fragmentParams.toString()
}
